import { gql } from 'apollo-angular';

export const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationFragment on Organization {
    id
    name
    shortName
  }
`;
